import type { UseQueryOptions } from '@tanstack/react-query';

import { iamGetUserAccessRules } from '@crossnokaye/typescript-sdk/funcs/iamGetUserAccessRules';
import { GetUserAccessRulesResponseBody } from '@crossnokaye/typescript-sdk/models/components';
import { SDKError } from '@crossnokaye/typescript-sdk/models/errors';
import {
  GetUserAccessRulesRequest,
  GetUserAccessRulesResponse,
} from '@crossnokaye/typescript-sdk/models/operations';

import { AtlasClientFunction } from '@/client/types';

const transformUserAccessRulesResponse = (
  response: GetUserAccessRulesResponse
): GetUserAccessRulesResponseBody | undefined => {
  return response.getUserAccessRulesResponseBody;
};

export interface UserAccessRulesQueryProps {
  userId: string;
  client: AtlasClientFunction;
  transform?: (response: GetUserAccessRulesResponse) => GetUserAccessRulesResponseBody | undefined;
}

export const userAccessRulesQuery = ({
  userId,
  client,
  transform = transformUserAccessRulesResponse,
}: UserAccessRulesQueryProps): UseQueryOptions<
  GetUserAccessRulesResponse,
  SDKError,
  GetUserAccessRulesResponseBody | undefined
> => {
  return {
    queryKey: ['userAccessRules', userId],
    queryFn: () =>
      client<GetUserAccessRulesRequest, GetUserAccessRulesResponse>({
        atlasFunc: iamGetUserAccessRules,
        request: { userId },
      }),
    staleTime: Infinity,
    select: transform,
    enabled: !!userId,
  };
};
